export type PaymentId = number

export type CreditCardId = string

export type CreditCardToken = string

export enum CreditCardBrand {
  VISA = 'Visa',
  MASTER = 'MasterCard',
  JCB = 'JCB',
  AMEX = 'American Express',
  DINERS = 'Diners Club',
  DISCOVER = 'Discover',
}

export interface ApiCreditCard {
  cardId: CreditCardId // TODO: API側でcardIdではなくidとして返す
  brand: CreditCardBrand
  last4: string
  expMonth: string
  expYear: number
  name: string
  default: boolean
}

export interface CreditCard {
  id: CreditCardId
  brand: CreditCardBrand
  last4: string
  expMonth: string
  expYear: number
  name: string
  default: boolean
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CreditCardCreateResponse {}

export enum ChargeType {
  BULK = 0,
  SHORTAGE = 1,
}

export interface ChargeCreditResponse {
  paymentId: PaymentId
  point: number
}

export interface PurchaseHistory {
  id: number
  price: number
  purchasedAt: string
}

export interface PurchaseHistoryResponse {
  purchaseLog: PurchaseHistory[]
}

export interface IssueReceiptParams {
  email: string
  name: string
}
